module.exports = __webpack_public_path__ + "img/4.e750878d.png";